import { AddBeneficiary, type addBeneficiaryIntentType, ModalParts } from 'BreetComponents';
import { closeModal, openModal, selectModals, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

const DialogAddBeneficiary = () => {
	const modals = useAppSelector(selectModals);

	const dispatch = useAppDispatch();

	const activeModal = modals.find((modalItem) => modalItem.id === 'addbeneficiary');

	const intentObject = activeModal?.metadata as { intent: addBeneficiaryIntentType } | undefined;

	const onSuccess = useCallback(() => {
		if (intentObject?.intent === 'enable automatic settlement') {
			dispatch(openModal({ id: 'autoSettlement' }));
			dispatch(closeModal('addbeneficiary'));
		}
	}, [dispatch, intentObject?.intent]);

	const exitModal = useCallback(() => {
		dispatch(closeModal('addbeneficiary'));
	}, [dispatch]);

	return (
		<ModalParts.Wrapper
			rightSheet
			title='Add Account'
			handleBackLink={exitModal}
		>
			<AddBeneficiary
				noBeneficiary
				intent={intentObject?.intent}
				onSuccess={onSuccess}
			/>
		</ModalParts.Wrapper>
	);
};

export default DialogAddBeneficiary;
